import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAJJZXryXZ9tFne5Ek6lbabAbeH-bvUE4M",
  authDomain: "kpi-bensco-web.firebaseapp.com",
  projectId: "kpi-bensco-web",
  storageBucket: "kpi-bensco-web.firebasestorage.app",
  messagingSenderId: "402004240612",
  appId: "1:402004240612:web:3c5f238561d45ff623a4f1",
  measurementId: "G-LGZC5F3JEM",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
